import React from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {NumericFormat as NumberFormat} from "react-number-format";
import {ESTADOS_VENTA} from "./estadosVenta";

/**
 * La fila de tarjetas arriba del listado de ventas.
 *
 * <p>Es el resumen y el selector a la vez: cada tarjeta dice cuántas ventas hay en ese estado y por
 * cuánta plata, y tocarla abre esa solapa. Las solapas siguen abajo —quien ya sabe dónde ir no tiene
 * que pasar por acá—, pero el que entra de cero necesita ver primero el panorama: sin esto, la
 * pantalla abría en "Pendientes de pago" sin ninguna pista de que había tres ventas cobradas
 * esperando que las despache.
 *
 * <p>El monto va debajo del número porque es lo que hace accionable a la tarjeta: "3 ventas" no
 * mueve a nadie, "3 ventas / $840.000 sin cobrar" sí.
 */
export const VentasResumen = ({totales, activo, onSelect}) => (
    <div className="ventasResumen">
        {ESTADOS_VENTA.map((estado) => {
            const cantidad = totales["total" + estado.key] || 0;
            const monto = totales["monto" + estado.key] || 0;
            const seleccionada = activo === estado.key;

            return (
                <button
                    key={estado.key}
                    type="button"
                    className="ventasResumen__card"
                    data-tono={estado.tono}
                    aria-pressed={seleccionada}
                    title={estado.ayuda}
                    onClick={() => onSelect(estado.key)}
                >
                    <span className="ventasResumen__icono">
                        <FontAwesomeIcon icon={estado.icono}/>
                    </span>

                    <span className="ventasResumen__datos">
                        <span className="ventasResumen__titulo">{estado.titulo}</span>
                        <span className="ventasResumen__cantidad">{cantidad}</span>
                        <span className="ventasResumen__monto">
                            <NumberFormat
                                prefix={"$"}
                                value={monto}
                                displayType={"text"}
                                thousandSeparator="."
                                decimalSeparator=","
                                decimalScale={0}
                            />
                        </span>
                    </span>
                </button>
            );
        })}
    </div>
);
